export const PC_ENABLE_CACHE_KEY = 'premium-credit-enable';
